/**
 * presenceCount — un registre de présence : un écran est-il là pour tenir un rôle ?
 *
 * Un compteur et non un booléen : deux écrans peuvent tenir le rôle à la fois (le live et sa page de
 * fin, empilés), et un écran qui se remonte (une clé qui change) ne doit pas effacer la présence de
 * celui qui monte.
 */
export function createPresenceCount() {
    let holders = 0
    return {
        /**
         * Un écran prend le rôle : rend la fonction qui le relâche (une seule fois).
         * @returns {() => void}
         */
        hold() {
            holders += 1
            let released = false
            return () => {
                if (released) return
                released = true
                holders = Math.max(0, holders - 1)
            }
        },
        /** @returns {boolean} */
        held() {
            return holders > 0
        },
    }
}
